import { FC, useRef, useState } from 'react';
import { FormattedMessage } from 'react-intl';

import { IconSettings } from '@xing-com/icons';
import { Label } from '@xing-com/label';
import { Toggle } from '@xing-com/toggle';
import { spaceM } from '@xing-com/tokens';

import {
  getAllowAutoplayState,
  setDefaultAllowAutoplayState,
} from '../../../utils/settings';

import * as Styled from './autoplay-settings.styles';

/* Note: We are forcing to read the getAllowAutoplayState value everytime that the user expands the settings
and we are collapsing the settings after a few seconds to be sure that it's consistent when using multiple players */

export const AutoplaySettings: FC = () => {
  const timer = useRef<NodeJS.Timeout | undefined>(undefined);
  const [isOpen, setIsOpen] = useState(false);
  const [isEnabled, setIsEnabled] = useState(getAllowAutoplayState());

  const expandCollapseHandler = (shouldExpand = !isOpen): void => {
    if (shouldExpand) {
      timer.current = setTimeout(() => expandCollapseHandler(false), 5000);
    } else {
      clearTimeout(timer.current);
      timer.current = undefined;
    }
    setIsOpen(shouldExpand);
    setIsEnabled(getAllowAutoplayState());
  };

  const autoplayToggle = (): void => {
    const newIsEnabled = !isEnabled;
    setIsEnabled(newIsEnabled);
    setDefaultAllowAutoplayState(newIsEnabled.toString());
  };

  return (
    <Styled.Container $autoplayEnabled={isEnabled}>
      <Styled.ToggleContainer $autoplayExpaded={isOpen}>
        <Label>
          <Toggle
            className="toggle xing-vjs-autoplay-toggle"
            on={isEnabled}
            onChange={autoplayToggle}
          />
          <span style={{ marginLeft: spaceM }}>
            <FormattedMessage id="VIDEOS_AUTOPLAY" defaultMessage="Autoplay" />
          </span>
        </Label>
      </Styled.ToggleContainer>
      <Styled.ExpandCollapseButton
        className="xing-vjs-settings-button"
        type="button"
        onClick={() => expandCollapseHandler()}
      >
        <Styled.Icon>
          <IconSettings width={19} height={19} />
        </Styled.Icon>
      </Styled.ExpandCollapseButton>
    </Styled.Container>
  );
};
